import { Box } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import React from 'react';
import routes from '../../helpers/routes';
import { Business } from '../../types/business';
import BusinessProfileInfo from '../Business/BusinessProfileInfo';
import SearchResultPlaceholder from './SearchResultPlaceholder';
import { useStyles } from './SearchResultsResultsContainer.styles';
import AnalyticsWrappedComponent from '../Analytics/AnalyticsWrappedComponent';

const SearchResultsResultsContainer = ({
  searchResults = [],
  marginBottom = 0,
  loading = true,
  placeholderCount = 12,
}: {
  searchResults?: Business[];
  marginBottom?: number;
  loading?: boolean;
  placeholderCount?: number;
}) => {
  const classes = useStyles();
  const theme = useTheme();

  return (
    <Box
      className={classes.resultsContainer}
      display="grid"
      gridTemplateColumns="repeat(auto-fit, minmax(500px, 1fr))"
      gridAutoRows="auto"
      gap={theme.spacing(2)}
      mb={marginBottom}
      flexGrow="1"
      id="resultsContainer"
    >
      {loading &&
        Array.from({ length: placeholderCount }, (x, i) => i).map((n) => {
          return <SearchResultPlaceholder key={n} />;
        })}
      {!loading &&
        searchResults.map((business) => (
          <Box key={business.id}>
            <AnalyticsWrappedComponent
              componentType="a"
              eventText="Clicked Business"
              eventLabel="Search Results"
              data-track-click={`Search Results, Navigation, ${business.name}`}
              href={routes.businesses(business.primarySlug)}
              rel="noreferrer"
              target="_blank"
              style={{
                textDecoration: 'none',
                cursor: 'pointer',
                height: '100%',
              }}
              key={business.id}
            >
              <BusinessProfileInfo
                view="serp"
                business={business}
                logoSize="sm"
                fullAbout={false}
              />
            </AnalyticsWrappedComponent>
          </Box>
        ))}
    </Box>
  );
};

export default SearchResultsResultsContainer;
